import { SLA_SOON_SECONDS } from '../constants';

const ISO_DURATION = /^(-)?P(?:(-?\d+)D)?(?:T(?:(-?\d+)H)?(?:(-?\d+)M)?(?:(-?[\d.]+)S)?)?$/;

export type SlaTone = 'overdue' | 'soon' | 'ok';

/** ISO-8601 duration (also with negative components, as java.time prints them) to seconds. */
export const parseIsoDurationSeconds = (value?: Nullable<string>): Nullable<number> => {
  if (!value) {
    return null;
  }

  const match = value.match(ISO_DURATION);

  if (!match) {
    return null;
  }

  const [, negative, days, hours, minutes, seconds] = match;
  const total =
    Number(days || 0) * 86400 + Number(hours || 0) * 3600 + Number(minutes || 0) * 60 + Number(seconds || 0);

  return negative ? -total : total;
};

export const secondsUntil = (isoDateTime: string, now: number = Date.now()): number =>
  (new Date(isoDateTime).getTime() - now) / 1000;

export const getSlaTone = (seconds: number): SlaTone => {
  if (seconds < 0) {
    return 'overdue';
  }

  return seconds < SLA_SOON_SECONDS ? 'soon' : 'ok';
};

export const formatRemaining = (seconds: number): string => {
  const abs = Math.abs(seconds);
  const days = Math.floor(abs / 86400);
  const hours = Math.floor((abs % 86400) / 3600);
  const minutes = Math.floor((abs % 3600) / 60);
  let text = `${minutes}m`;

  if (days) {
    text = `${days}d ${hours}h`;
  } else if (hours) {
    text = `${hours}h ${minutes}m`;
  }

  return seconds < 0 ? `overdue ${text}` : `${text} left`;
};
